export default __webpack_public_path__ + "static/media/Atom.a9aaa4e9.svg";